module.exports = __webpack_public_path__ + "img/banner_2025.808bfed3.png";